import { FC } from 'react';
import { MessageSchema } from 'src/types/chat';
import { StyledReplyMessageBubble, StyledReplyMessageOwner } from './styled';

type Props = {
    sentByMe: boolean;
    replyMessage: MessageSchema;
};

const ReplyMessageBubble: FC<Props> = ({ replyMessage, sentByMe }) => {
    return (
        <StyledReplyMessageBubble sentByMe={sentByMe}>
            <StyledReplyMessageOwner sentByMe={sentByMe}>
                {sentByMe ? 'me' : replyMessage?.senderAlias || 'Unknown'}
            </StyledReplyMessageOwner>
            {replyMessage?.text}
        </StyledReplyMessageBubble>
    );
};

export default ReplyMessageBubble;
